<template>
  <div>
    <h2 class="verification-details__title">
      {{ 'verification-bdd-form.title' | globalize }}
    </h2>
    <form
      class="verification-cdd-form"
      @submit.prevent="isFormValid() && showConfirmation()"
      novalidate
    >
      <div class="verification-cdd-form__section">
        <customer-risk-factors
          :former="former"
          :is-disabled="formMixin.isDisabled"
        />
      </div>

      <div class="verification-cdd-form__section">
        <product-service-risk-factors
          :former="former"
          :is-disabled="formMixin.isDisabled"
        />
      </div>

      <div class="verification-cdd-form__section">
        <verification-form-geo-risk
          :former="former"
          :is-disabled="formMixin.isDisabled" />
      </div>

      <div class="verification-cdd-form__section">
        <verification-form-pep
          :former="former"
          :user-details="userDetails"
          :is-disabled="formMixin.isDisabled" />
      </div>

      <div class="verification-cdd-form__section">
        <verification-form-check-list
          :former="former"
          :user-details="userDetails"
          :is-disabled="formMixin.isDisabled" />
      </div>

      <div class="verification-cdd-form__section">
        <verification-form-risk-assmnt
          :former="former"
          :is-disabled="formMixin.isDisabled" />
      </div>

      <div
        v-if="!isVerificationComplete"
        class="app__form-actions verification-cdd-form__actions">
        <form-confirmation
          v-if="formMixin.isConfirmationShown"
          :is-pending="isFormSubmitting"
          @ok="chooseMethod"
          @cancel="hideConfirmation"
        />
        <template v-else>
          <div class="verification-cdd-form__buttons-first-block">
            <permission-wrapper
              skip-alert
              page-name="verifications"
              resource-name="verification"
              action-name="update_foreign">
              <button
                v-ripple
                class="app__form-submit-btn app__button-raised"
                @click="verificationStatus = REQUEST_STATUSES.approved"
                :disabled="formMixin.isDisabled"
              >
                {{ 'verification-cdd-form.btn-approve' | globalize }}
              </button>
              <button
                v-ripple
                class="app__form-submit-btn app__button-raised--danger"
                @click="verificationStatus = REQUEST_STATUSES.rejected;
                        showConfirmation()"
                :disabled="formMixin.isDisabled"
              >
                {{ 'verification-cdd-form.btn-reject' | globalize }}
              </button>
            </permission-wrapper>
          </div>
          <div class="verification-cdd-form__buttons-second-block">
            <permission-wrapper
              skip-alert
              page-name="verifications"
              resource-name="verification"
              action-name="update_foreign">
              <!-- eslint-disable -->
              <button
                v-ripple
                class="app__form-submit-btn app__button-raised--primary"
                @click.prevent="verificationStatus = REQUEST_STATUSES.in_progress;
                              showConfirmation()"
                :disabled="formMixin.isDisabled && isFormSubmitting"
              >
                {{ 'verification-cdd-form.btn-continue' | globalize }}
              </button>
              <button
                class="app__form-submit-btn
                app__button-raised
                app__button-raised--attention"
                @click="verificationStatus = REQUEST_STATUSES.discard;
                      showConfirmation()"
                :disabled="formMixin.isDisabled"
              >
                {{ 'verification-cdd-form.btn-discard' | globalize }}
              </button>
            </permission-wrapper>
          </div>
        </template>
      </div>

      <textarea-field
        class="verification-cdd-form__field"
        v-if="verificationStatus === REQUEST_STATUSES.rejected && reason"
        v-model="reason"
        @input="former.setAttr('rejectReason.reason', reason)"
        :label="'verification-cdd-form.lbl-reason' | globalize"
        :disabled="isFormSubmitting || Boolean(verificationDetails.reason.reason)"
      />
    </form>
  </div>
</template>

<script>
import { VerificationBDDFormer } from '@/js/formers/VerificationBDDFormer'
import CustomerRiskFactors from '@/vue/forms/VerificationBDDForm/components/CustomerRiskFactors'
import ProductServiceRiskFactors from '@/vue/forms/VerificationBDDForm/components/ProductServiceRiskFactors'
import GeoRiskFactors from '@/vue/forms/VerificationCDDForm/components/VerificationFormGeoRisk'
import VerificationFormRiskAssmnt from '@/vue/forms/VerificationCDDForm/components/VerificationFormRiskAssmnt'
import VerificationFormPEP from '@/vue/forms/VerificationCDDForm/components/VerificationFormPEP'
import VerificationFormCheckList from '@/vue/forms/VerificationCDDForm/components/VerificationFormCheckList'
import CDD from '../VerificationCDDForm/VerificationCDDForm'
import PermissionWrapper from '@/vue/common/permission-wrapper'

export default {
  name: 'verification-bdd-form',
  components: {
    CustomerRiskFactors,
    ProductServiceRiskFactors,
    'verification-form-geo-risk': GeoRiskFactors,
    VerificationFormRiskAssmnt,
    'verification-form-pep': VerificationFormPEP,
    'verification-form-check-list': VerificationFormCheckList,
    PermissionWrapper,
  },
  extends: CDD,
  created () {
    this.former = new VerificationBDDFormer(this.verificationDetails.manual)

    if (this.isVerificationComplete) {
      this.disableForm()
    }
  },
}
</script>

<style lang="scss">
  @import '../VerificationCDDForm/verification-cdd-form';

  h2.verification-details__title {
    margin-top: 3rem;
  }
</style>
